export const API_STATUS = {
  CONFLICT: 409,
};
